/* eslint-disable global-require */
/* eslint-disable import/prefer-default-export */
/*
 * @Author: mcdowell
 * @Date: 2021-09-17 15:22:53
 * @LastEditors: mcdowell
 * @LastEditTime: 2021-09-17 15:40:06
 */

export const contactList = [
    {
        name: 'facebook',
        icon: require('./images/FaceBook.png'),
        href: 'https://www.facebook.com/AlphaLiveCommunity'
    },
    {
        name: 'twitter',
        icon: require('./images/twitter.png'),
        href: 'https://twitter.com/AlphaLiveMena'
    },
    {
        name: 'instagram',
        icon: require('./images/ins.png'),
        href: 'https://www.instagram.com/royallivearabia'
    },
    {
        name: 'youtube',
        icon: require('./images/youtube.png'),
        href: 'https://www.youtube.com/channel/UCZ2BgD6zagXyo8LvUh-VvxA'
    }
];
